<script setup lang="ts">
import { ButtonNavigation } from '~/lib/models/ui/bottom-navigation'
import {
  MobileBottomNavLinkBehaviour,
  MobileBottomNavLink,
} from '~/lib/services/content/content.configuaration.dtos'

const authStore = useAuthStore()

const props = defineProps<{
  showNavigationBar: boolean
}>()

const origin = useSiteDomain({ protocol: true, noOverride: true })

const mobileBottomNav = useConfiguration('mobile-bottom-navigation')

const buttons = computed<ButtonNavigation[]>(() => {
  if (!mobileBottomNav) return []
  const btnsGrouped: MobileBottomNavLink[][] = []
  const indexes = [1, 2, 3, 4]

  // Divide buttons by position
  indexes.forEach((index: number) => {
    const idxBtnArr = mobileBottomNav.links.filter(({ position }) => position === index)
    if (idxBtnArr.length) btnsGrouped.push(idxBtnArr)
  })

  // Return button navigation on current moment
  return btnsGrouped.map((btnGroupArr: MobileBottomNavLink[]) => {
    const both = btnGroupArr.find(btn => btn.behaviour === MobileBottomNavLinkBehaviour.BOTH)
    if (both) return mobileNavLinkToButtonNavigation(both)
    const logged = btnGroupArr.find(btn => btn.behaviour === MobileBottomNavLinkBehaviour.LOGGED)
    const unlogged = btnGroupArr.find(
      btn => btn.behaviour === MobileBottomNavLinkBehaviour.UNLOGGED
    )
    if (logged && unlogged) {
      return authStore.isUserLogged
        ? mobileNavLinkToButtonNavigation(logged)
        : mobileNavLinkToButtonNavigation(unlogged)
    }
    return mobileNavLinkToButtonNavigation(btnGroupArr[0])
  })
})

useJsonld(() => {
  if (!props.showNavigationBar || !buttons.value.length) return null
  return {
    '@context': 'https://schema.org',
    '@graph': buttons.value.map(btn => ({
      '@context': 'https://schema.org',
      '@type': 'SiteNavigationElement',
      '@id': '#header',
      'name': btn.title,
      'url': `${origin}${btn.path}`,
    })),
  } as any
})

const mobileNavLinkToButtonNavigation = (navLink: MobileBottomNavLink) => {
  const {
    link: { title, icon, page, url },
  } = navLink
  return {
    title: title || '',
    icon: icon?.url || '',
    path: page?.path || url || '/',
  }
}
</script>

<template>
  <div
    v-if="props.showNavigationBar && buttons.length"
    class="fixed bottom-0 left-0 z-10 h-16 w-full"
  >
    <section
      class="flex justify-around rounded-t-lg bg-white py-2 shadow-[6px_-1px_27px_13px_#00000024]"
    >
      <ButtonNavigationBar
        v-for="button in buttons"
        :key="button.title"
        data-test="bottom-navigation-button"
        :button-navigation="button"
      />
    </section>
  </div>
</template>
